export class Therapy2 {
  done: string;
  onGoing: string;
  dateOfStart: string;
  dateInput: string;

  constructor(done: string, onGoing: string, dateOfStart: string, dateInput: string) {
    this.done = done;
    this.onGoing = onGoing;
    this.dateOfStart = dateOfStart;
    this.dateInput = dateInput;
  }
}
